import type { CSSProperties } from 'react';

export const preferenceModalBodyStyle: CSSProperties = {
    boxSizing: 'border-box',
    maxWidth: '100%',
    minWidth: 0,
    overflowX: 'hidden',
};
